import { sendAPIRequest } from "shared/utils/requests";

import React, { Component } from "react";
import _ from "lodash";
import { Radio, RadioGroup } from "@blueprintjs/core";
import QuizQuestion from './quizQuestion'
import Button from "../base-components/button"
import classNames from "classnames";
import {FAQ_DOCUMENT_URL} from '../../utils/index.js';

class Faq extends Component {
  constructor(props) {
    super(props);

    const { faqQuiz } = this.props;
    this.state = {
      faqQuizForm: faqQuiz.map((item) => {
        item = Object.assign({}, item);
        item.selectedAnswerIndex = null;
        return item;
      }),
      grades: [],
      failed: false,
    };
  }

  renderDivider(text) {
    return (
      <div className="onboarding-privacy-divider">
        <div className="onboarding-privacy-divider-accent" />
        {text}
        <div className="onboarding-privacy-divider-divider" />
      </div>
    );
  }

  renderHeader() {
    return (
      <div className="onboarding-privacy-item">
        <div className="onboarding-privacy-item-title">
          Review Our FAQs & Take the Quiz
        </div>
        <div className="onboarding-privacy-item-subtitle">
          The FAQ is how we refer to our document of all QA World guidelines and regulations. This document has all the information you need to succeed with respect to transcription guidelines and payment and QA world rules guidelines. We always follow the FAQ and if you fully understand this document and take the time to read it you will be able to make so much more money.
        </div>
      </div>
    );
  }

  renderQuizItem(item, wrongIndex, itemIndex) {
    return (
      <QuizQuestion index={itemIndex + 1} question={item.question} answers={item.answers} wrongIndex={wrongIndex} key={itemIndex} setAnswerIndex={answer => {
        const newState = JSON.parse(JSON.stringify(this.state.faqQuizForm))
        newState[itemIndex].selectedAnswerIndex = answer;
        this.setState({ faqQuizForm: newState });
      }} />
    );
  }

  async submitQuiz() {
    const {
      updateOnboardingStep,
    } = this.props;

    const {
      faqQuizForm,
    } = this.state;

    const response = await sendAPIRequest(`/onboarding/submit_faq_quiz`, "POST", { answers: faqQuizForm.map(item => item.selectedAnswerIndex) });
    if (response.data.status == 'success') {
      updateOnboardingStep(response.data.onboardingStep);
    } else if (response.data.status == 'failure') {
      this.setState({ grades: response.data.grades, failure: true });
    } else {
      throw new Error("invalid status for faq quiz submission: " + response.data.status)
    }
  }

  renderQuiz() {
    const {
      faqQuizForm,
      grades,
    } = this.state;

    return (
      <form className="onboarding-privacy-quiz">
        {faqQuizForm.map((item, i) => {
          return this.renderQuizItem(item, grades[i] == null || grades[i].correct ? -1 : grades[i].response, i)
        })}
      </form>
    );
  }

  render() {

    const {
      failure,
    } = this.state;

    const messageClasses = classNames({
      'onboarding-error-label': true,
      'onboarding-error-label-hidden': !failure,
    });
    return (
      <div className="onboarding-privacy-container">
        {this.renderHeader()}

        {this.renderDivider('FAQ')}

        <iframe className="onboarding-faq-doc" src={FAQ_DOCUMENT_URL}></iframe>

        {this.renderDivider('QUIZ')}

        {this.renderQuiz()}

        <div className={messageClasses}>
          You didn{"'"}t pass the FAQ quiz. Please re-read the FAQ, update <br />
          your incorrect answers, and re-submit. You can retake the quiz until you pass.
        </div>

        <div className="onboarding-divider"/>
        <div className="onboarding-submission">
          <Button className="onboarding-submission-button" onClick={() => this.submitQuiz()} text="Submit Answers & Continue" />
        </div>
      </div>
    );
  }

}

export default Faq;
